module.exports = __webpack_public_path__ + "static/shawn-befd3f8acaf73a92d97831117a323378.png";